<template>
    <div
        v-if="domainLogin"
        class="login-btn"
        ref="domainLogin"
        @click="login"
        :class="{ loading: loading, openModal: showLoginModal, enable: countdown > 0 }"
    >
        <span class="entry-input_button-domainLogin">
            <span>{{ $i18n(loginName) }}</span>
            <i @click.stop="clickDomainButton"></i>
        </span>
        <span v-show="countdown" style="margin-left: 20px;"> ({{ countdown }}s)</span>
        <login-model
            class="user-container"
            v-if="showLoginModal"
            :activeIndex="loginType"
            :typeList="loginTypeName"
            @clickEvent="changeType"
        ></login-model>
    </div>
    <div v-else class="login-btn" :class="{ loading: loading }" @click="login">
        {{ $i18n('button.login') }}<span v-show="countdown > 0">({{ countdown }}s)</span>
    </div>
</template>

<script>
export default {
    name: 'camelliaLoginButton',

    props: {
        loading: {
            type: Boolean,
            default: false
        },
        loginAuthMethod: {
            type: String,
            default: '0'
        },
        loginType: {
            type: Number,
            default: 0
        },
        countdown: String
    },

    computed: {
        domainLogin() {
            return this.loginAuthMethod === 'systemOrAdDomain' ? true : false;
        },

        loginName() {
            return this.loginTypeName[this.loginType];
        }
    },

    components: { loginModel: () => import('./loginModel') },

    data() {
        return {
            showLoginModal: false,
            loginTypeName: ['button.normal', 'button.domain'],
            loginStyle: {}
        };
    },

    methods: {
        login() {
            this.$emit('login');
        },

        clickDomainButton() {
            this.showLoginModal = true;
        },

        changeType(index) {
            this.$emit('changeType', index);
            this.clearModal();
        },

        clearModal() {
            this.showLoginModal = false;
        }
    },

    mounted() {
        document.addEventListener('click', this.clearModal);
        window.addEventListener('resize', () => {
            this.clearModal();
            this.loginStyle = {};
        });
    },

    beforeDestroy() {
        document.removeEventListener('click', this.clearModal);
    }
};
</script>

<style scoped lang="scss">
.login-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 264px;
    height: 36px;
    font-size: 12px;
    color: #fff;
    background-color: #0a4196;
    border-radius: 4px;
    outline: none;
    margin: auto;
    position: relative;
    cursor: pointer;
    &.loading {
        background-color: rgba(0, 0, 0, 0.2) !important;
        pointer-events: none;
    }
    &.enable {
        cursor: not-allowed;
    }
    .entry-input_button-domainLogin {
        position: relative;
        i {
            position: absolute;
            right: -14px;
            top: 18px;
            border-bottom: 4px solid #fff;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            transition: all 0.3s linear;
            transform-origin: 50% 70%;
        }
        i::after {
            content: '';
            position: absolute;
            top: -16px;
            bottom: -22px;
            left: -7px;
            right: -8px;
        }
    }

    &.openModal {
        border-radius: 4px 4px 0 0;
        i {
            transform: rotateZ(180deg);
        }
    }
    .user-container {
        color: #000;
        top: 42px;
        z-index: 1;
    }
}

@media screen and (max-width: 420px) {
    .login-btn {
        width: 284px;
        font-size: 16px;
        background-color: #007aff;
    }
}
</style>
